import '../scss/style.scss';
import $ from 'jquery';
import WOW from 'wow.js';

// Page Script
import HomePage from './pages/homePage';
import PersonDetailPage from './pages/personDetailPage';

// Module Script
//import Hero from './modules/hero';
import GoogleMap from './modules/acf-map';
import Slider from './modules/basic-slider';
import Sharebutton from './modules/sharebutton';
import ListToggle from './modules/list-expander';
import Testimonial from './modules/testimonial-slider';
import HeaderScrollObserver from './modules/header-observer';
import Toggles from './modules/toggles';
//import parallaxImages from './modules/parallaxImages';

import './libs/animsition.min.js';

const init = () => {

    $(".animsition").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 1500,
        outDuration: 800,
        linkElement: '.anim', // a:not(target="_blank"):not([href^="#"]):not([href^="#0"])
        loading: true,
        loadingParentElement: 'body',
        loadingClass: 'animsition-loading',
        loadingInner: '',
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: ['animation-duration', '-webkit-animation-duration'],
        overlay: false,
        overlayClass: 'animsition-overlay-slide',
        overlayParentElement: 'body',
        transition: function(url) {
            window.location.href = url;
        }
    });

    const wow = new WOW();
    wow.init();

    function setCurrentYear() {
        var elem = document.getElementById('js-year');
        var text = document.createTextNode(new Date().getFullYear());
        elem.appendChild(text);
    }

    // Page
    HomePage();
    PersonDetailPage();

    // Modules
    //Hero();
    Slider();
    ListToggle();
    Sharebutton();
    Testimonial();
    HeaderScrollObserver();
    Toggles();
    //parallaxImages();
    setCurrentYear();

    $('a.downArrow').on('click',function(e) {
      e.preventDefault();
      $('html,body').animate({scrollTop: (window.innerHeight - 100)}, 500);
    });

    $('button.printBtn').on('click', function(e) {
      e.preventDefault();
      window.print();
    })

    // Crazy debug helper here:
    $(':contains("Lorem"),:contains(Ut enim)').each(function() {
      if ($(this).prop('tagName') == 'P' || $(this).prop('tagName') == 'H2' || $(this).prop('tagName') == 'H3' || $(this).prop('tagName') == 'H4' || $(this).prop('tagName') == 'UL' ) {
        $(this).addClass('loremipsum');
      }
    });

    if (document.querySelector('.acf-map') && typeof GoogleMap == 'function') {
      GoogleMap();
    }

}

// When DOM is ready, init function fire
document.addEventListener('DOMContentLoaded', e => { init() }, false);
